import axios from 'axios'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import Loading from './Loading'
import { If, Then, Else } from 'react-if'

const Register = () => {
    const address = useSelector((state) => state.address.value)
    const [userData, setUserData] = useState({
        address: '',
        id: '',
        referral: '',
        sponsor: '',
    })
    const [isLoading, setLoading] = useState(false)
    const history = useHistory()

    const signup = () => {
        setLoading(true)
        axios
            .post('api/register', {
                address: userData.address,
                name: userData.id,
                referral: userData.referral,
                sponsor: userData.sponsor,
            })
            .then((res) => {
                history.push('/')
                alert('Sign up is complete.')
                setLoading(false)
            })
            .catch((err) => {
                setLoading(false)
                if (err.response) {
                    console.log(err.response)
                    console.log(err.response.data.message)
                    alert(err.response.data.message)
                }
            })
    }

    const onChange = (e) => {
        const name = e.target.name
        const value = e.target.value
        setUserData({
            ...userData,
            address: address,
            [name]: value,
        })
    }
    function goHome() {
        history.push('/')
    }
    return (
        <If condition={isLoading}>
            <Then>
                <Loading />
            </Then>
            <Else>
                <div>
                    <div className="register-wrap">
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <p className="page-title text-center">New registration is not possible.</p>
                        {/* <form className="register-form" id="register">
                            <div className="form-group">
                                <input type="text" placeholder="ID" name="id" onChange={onChange} />
                            </div>
                            <div className="form-group">
                                <input type="text" placeholder="Referral" name="referral" onChange={onChange} />
                            </div>
                            <div className="form-group">
                                <input type="text" placeholder="Sponsor" name="sponsor" onChange={onChange} />
                                <div className="help color-gray text-left">Referral and Sponsor should be in the same group.</div>
                            </div>
                            <button type="button" className="btn w-100 btn-lg btn-primary pt-3 pb-3" onClick={signup}>
                                Sign up
                            </button>
                        </form> */}
                        <br />
                        <br />
                        <br />
                        <form className="register-form" id="register">
                            <button type="button" className="btn w-100 btn-lg btn-primary pt-3 pb-3" onClick={goHome}>
                                Go Home
                            </button>
                        </form>
                    </div>
                </div>
            </Else>
        </If>
    )
}
export default Register
